import styled from "styled-components";
import { useHistory } from "react-router-dom";
import store from "store";
import AssetMenuPopup from "modules/Common/Components/AssetMenuPopup";
import { useState } from "react";
import { ReactComponent as Ellipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import { ReactComponent as Mail } from "../../../assets/img/icons/mail.svg";
import { ReactComponent as Clock } from "../../../assets/img/icons/Clock.svg";
import { ReactComponent as Tiles } from "../../../assets/img/icons/Tiles.svg";
import { ReactComponent as Portal } from "../../../assets/img/icons/Portal.svg";
import { ReactComponent as Flow } from "../../../assets/img/icons/nav/Flow.svg";
import { Tooltip, Typography } from "antd";
import { createEmailService } from "modules/Services/CampaignsService";
import { CAMPAIGNS_LIST, EMAIL_LIST } from "constants/types";

interface Props {
  draftEmailIndex?: number;
  draftEmailId?: number;
  assetDeleteHandler?(draftEmailIndex: number, draftEmailId: string): void;
  title?: string;
  imgUrlOne?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  emailType?: any;
  published?: string;
  time?: string;
  grid?: boolean;
  portal?: boolean;
  email?: boolean;
  audience?: number | string;
  onCardClick?: () => void;
  campaignId?: any;
  automation?: boolean;
  isWfActionEmail?: boolean;
  workflowId?: string;
}

const DraftEmailCard: React.FC<Props> = (props) => {
  const {
    draftEmailIndex,
    draftEmailId,
    assetDeleteHandler,
    title,
    imgUrlOne,
    imgUrlTwo,
    imgUrlThree,
    published,
    emailType,
    onCardClick,
    campaignId,
    automation,
    isWfActionEmail,
    workflowId,
  } = props;

  const [ellipsisState, setEllipsistate] = useState(false);
  const { Paragraph } = Typography;
  let history = useHistory();

  const cloneDraftEmailToCurrentCampaign = (hide: () => void) => {
    store.dispatch({
      type: EMAIL_LIST.CLONE_DRAFT_IN_PROGRESS,
      payload: true,
    });
    title &&
      createEmailService(title, campaignId, undefined, draftEmailId?.toString(), 1)
        .then((res) => {
          const data = res.data;
          if (data.success) {
            store.dispatch({
              type: EMAIL_LIST.CLONE_DRAFT_SUCCESS,
              payload: { draftEmailId, data },
            });
            store.dispatch({
              type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
              campaign_id: campaignId,
              add: true,
            });
          }
          hide();
        })
        .catch((err) => {
          store.dispatch({
            type: EMAIL_LIST.CLONE_DRAFT_IN_PROGRESS,
            payload: false,
          });
          hide();
        });
  };

  const workflowHandler = (e) => {
    e.stopPropagation();
    history.push(`/automation/details?workflow_id=${workflowId}&from=campaigns&campaign_id=${campaignId}`);
  };

  return (
    <Wrapper
      onlyAsset={false}
      onClick={() => {
        if (onCardClick) onCardClick();
      }}
    >
      <div className={`preview ${emailType ? "adhoc-type" : ""}`}>
        <div className="pills">
          {props.email && (
            <span>
              <Mail />
            </span>
          )}
          {props.portal && (
            <span>
              <Portal />
            </span>
          )}
          {props.grid && (
            <span>
              <Tiles />
            </span>
          )}
          {props.time && (
            <div className="time">
              <Clock /> {props.time}
            </div>
          )}
        </div>
        {emailType == 0 ? (
          <div>
            <div
              className="preview-1"
              style={{
                backgroundImage: `url(
              ${imgUrlOne}
            )`,
              }}
            ></div>
            <div
              className="preview-2"
              style={{
                backgroundImage: `url(
              ${imgUrlTwo}
            )`,
              }}
            ></div>
            <div
              className="preview-3"
              style={{
                backgroundImage: `url(
              ${imgUrlThree}
            )`,
              }}
            ></div>
          </div>
        ) : (
          <div
            className="preview-adhoc"
            style={{
              backgroundImage: `url(
          ${imgUrlOne}
        )`,
            }}
          ></div>
        )}
      </div>
      <div className={`details ${automation ? "with-automation" : null}`}>
        <div className="name">
          {
            <Tooltip placement="top" title={ellipsisState ? props.title : undefined}>
              <Paragraph className="paragraph-styling" ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}>
                {title?.startsWith("[Cloned]") ? (
                  <>
                    {<text style={{ color: "#1EC252" }}>[Cloned]</text>} {title.substring(8)}
                  </>
                ) : (
                  title
                )}
              </Paragraph>
            </Tooltip>
          }
        </div>
        <div className="info">
          <span className="type">{`${emailType > 0 ? "Ad Hoc" : "Digest"} Email`}</span> |<span> {published}</span>
        </div>
        <div className="actions d-flex justify-content-between">
          <ul className="flex-grow-1 d-flex justify-content-between">
            <li className="card-popover">
              {automation ? (
                <span className="automation-icon" onClick={workflowHandler}>
                  <Flow />
                  {!isWfActionEmail && <span>Event</span>}
                </span>
              ) : null}
              <AssetMenuPopup
                id={draftEmailId}
                campaignId={campaignId}
                assetDeleteHandler={assetDeleteHandler}
                assetIndex={draftEmailIndex}
                emailType={emailType}
                cloneDraftEmailToCurrentCampaign={cloneDraftEmailToCurrentCampaign}
                emailName={title}
                workflowAutomation={automation}
                isWfActionEmail={isWfActionEmail}
              >
                {/* <a> */}
                <div>
                  <Ellipsis />
                </div>
                {/* </a> */}
              </AssetMenuPopup>
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
};

export default DraftEmailCard;

const Wrapper = styled.div<{ height?: string; width?: string; onlyAsset?: boolean }>`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  /* height: 280px; */
  height: 240px;
  margin-bottom: 50px;
  cursor: pointer;
  ${(props) => (props.onlyAsset ? "box-shadow: 0px 0px 0px 2px #27CE0A;" : "")}
  @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
    margin-bottom: 35px;
    /* ${(props) => (props.onlyAsset ? "height: 205px;" : "height: 220px;")} */
    ${(props) => (props.onlyAsset ? "height: 205px;" : "height: 180px;")}
  }
  .preview {
    position: relative;
    .pills {
      position: absolute;
      top: 14px;
      left: 12px;
      span,
      a {
        padding: 0 3px;
        float: left;
        svg {
          max-width: 18px;
          max-height: 18px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 13px;
            max-height: 13px;
          }
          path {
            fill: #fff;
          }
        }
      }
      .time {
        border-radius: 10px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.44);
        text-align: center;
        font-size: 10px;
        padding: 1px 7px;
        font-family: "robotobold";
        font-weight: 700;
        float: left;
        margin-top: 4px;
      }
    }
    .preview-adhoc {
      width: 100%;
      height: 136px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      // border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 96px;
      }
    }
    .preview-1 {
      width: 70%;
      height: 136px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 96px;
      }
    }
    .preview-2 {
      width: 30%;
      height: 67px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
    .preview-3 {
      width: 30%;
      height: 69px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
    &.adhoc-type {
      .preview-1 {
        width: 100%;
        border: none;
      }
      .preview-2,
      .preview-3 {
        display: none;
      }
    }
  }
  .details {
    padding: 14px 20px 10px 20px;
    background-color: #ffffff;
    float: left;
    width: 100%;
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 9px 13px 10px 13px;
    }
    &.with-automation {
      position: relative;
      .name {
        padding-right: 10px;
      }
      .actions {
        top: 15px !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          top: 8px !important;
        }
      }
      .automation-icon {
        width: 20px;
        svg {
          width: 20px;
          height: auto;
          g {
            fill: #27ce0a;
          }
        }
        span {
          color: #424b50;
          font-size: 8px;
          text-align: center;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          display: block;
          margin-left: -10px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            margin-left: -6px;
          }
        }
        + div {
          padding: 0 5px !important;
        }
      }
    }
    .name {
      color: #424b50;
      font-size: 22px;
      line-height: 24px;
      font-weight: 600;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
      height: 48px;
      width: calc(100% - 15px);
      -webkit-box-align: start;
      word-break: break-word;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
        line-height: 18px;
        height: 36px;
        min-height: 36px;
      }
      p,
      div {
        margin-bottom: 0;
      }
    }
    .info {
      color: #7e7e7e;
      font-size: 12px;
      font-family: "robotomedium";
      margin-bottom: 10px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-align: start;
      clear: both;
      width: 100%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        margin-bottom: 9px;
      }
      .type {
        color: #db3725;
      }
    }
    .actions {
      position: absolute;
      top: 35px;
      right: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: 15px;
      }
      ul {
        list-style: none;
        margin: 0 -10px;
        padding: 0;
        li {
          display: block;
          padding: 0 3px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 0;
          }
          a {
            padding: 0 2px;
            text-align: center;
            display: block;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 0 3px;
            }
            svg {
              width: 18px;
              max-height: 12px;
              @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                max-height: 9px;
                width: auto;
              }
              path {
                fill: #000000;
                opacity: 0.5;
              }
              g {
                opacity: 1;
              }
            }
            span {
              color: #5e7079;
              font-size: 10px;
              font-family: "helveticaneuebold";
              font-weight: 700;
              display: block;
              text-align: center;
              @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 7px;
              }
            }
          }
          &.card-popover {
            float: right;
            div {
              padding: 5px;
              svg {
                width: 8px;
                max-height: none;
                @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  width: 3px;
                }
              }
            }
            /* a {
              svg {
                width: 8px;
                max-height: none;
              }
            } */
          }
          &:hover {
            a {
              svg path {
                fill: #27ce0a;
              }
            }
          }
        }
      }
    }
    .only-asset-actions {
      background-color: rgb(30 194 82 / 11%);
      height: 40px;
      margin: 15px -20px -20px -20px;
      align-items: center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 30px;
        margin-top: 0px;
      }
      svg {
        margin-right: 5px;
        min-width: 20px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          min-width: 12px;
        }
      }
      :hover {
        cursor: pointer;
      }
      div {
        max-width: 100%;
      }
      .save-to-campaign {
        display: flex;
        align-items: center;
        color: #27ce0a;
        border: 0;
        font-family: "robotomedium";
        font-size: 14px;
        margin: 0 5px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        box-sizing: border-box;
        display: block;
        letter-spacing: -0.5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 14px;
          }
        }
      }
    }
  }
`;
